export const MARKET_DATA = '/market-data';
export const MarketDataPath = {
  ShareSearch: `${MARKET_DATA}/share-search`,
};

export default {
  MarketDataPath,
};
